<!-- TODO: The tooltips here require a workaround for container that we'll need to replace with a more official version from ng-base once its available -->
<bento-alert [items]="alerts"></bento-alert>
<div class="alert alert-warning conflicts-found"><span>{{'onvio.setup.migrations.conflictsFoundWarning' | translate}}</span></div>
<ng-container *ngIf="(conflicts$ | async) as conflicts; else loading">
	<!-- Header Toolbar -->
	<bento-toolbar class="bento-toolbar" data-qe-id="nucleus-migration-conflicts-header-toolbar">
		<div class="navbar-left">
			<div aria-live="polite" aria-atomic="true" class="conflict-count">
				<h3>{{'onvio.setup.migrations.conflictsNumber' | translate}} <span class="badge badge-primary">{{conflicts.length}}</span></h3>
			</div>
		</div>
		<div class="navbar-right">
			<button
				#submitResolutionButton
				class="btn btn-primary submit-button"
				(click)="submitResolved(conflicts.items)"
				[disabled]="resolutionButtonDisabled$ | async"
				attr.data-qe-id="{{migrationSource.toLowerCase()}}-nucleus-migration-conflicts-header-submit-button">
				{{'onvio.setup.migrations.submitResolved' | translate}}
			</button>
		</div>
	</bento-toolbar>
	<!-- Conflicts Grid -->
	<wj-flex-grid
		#flexGrid
		class="bento-flex-grid"
		[bentoBusyLoader]="showBusyLoader"
		[itemsSource]="conflicts"
		[itemFormatter]="itemFormatter"
		[isReadOnly]="true"
		[stickyHeaders]="true"
		[showSort]="true"
		[headersVisibility]="'Column'"
		[selectionMode]="'None'">
		<div *ngIf="showBusyLoader" class="busy-loader-text">
			<p><strong>{{ 'onvio.setup.migrations.pleaseWait' | translate }}</strong></p>
		</div>
		<ng-template wjFlexGridCellTemplate [cellType]="'RowHeader'" let-row="row">{{row.dataIndex + 1}}</ng-template>
		<ng-template wjFlexGridDetail #dp="wjFlexGridDetail" [detailVisibilityMode]="visibilityMode" let-item="item" let-row="row">
			<div class="migration-conflict-detail-table-container" *ngIf="!item.refreshing; else loading">
				<div aria-live="polite" aria-atomic="true" class="conflict-detail-header">
					<h4>{{ 'onvio.setup.migrations.compareIncoming' | translate: { application: productName } }}</h4>
				</div>
				<!-- Table -->
				<table class="table table-bordered migration-conflict-detail-table">
					<thead>
						<th>
							<a 	data-qe-id="{{migrationSource.toLowerCase()}}-nucleus-migration-conflicts-conflict-unselect-link-{{row.dataIndex}}"
								class="btn-link"
								role="button"
								(click)="item.choice = undefined; checkForResolutions(conflicts.items)"
								[class.disabled]="(item.isResolved$ | async) === false || item.resolvedOnUpdate">
								{{'onvio.setup.migrations.unselect' | translate}}
							</a>
						</th>
						<th></th>
						<th *ngFor="let prop of item.conflictEntityConfig.properties">
							<div attr.data-qe-id="{{migrationSource.toLowerCase()}}-nucleus-migration-conflicts-conflict-{{row.dataIndex}}-{{prop.name}}">{{prop.translationKey | translate}}</div>
						</th>
					</thead>
					<!-- New Record body -->
					<tbody>
						<tr>
							<td class="match-input-cell">
								<span>
									<input
										type="radio"
										id="existing-{{row.dataIndex}}"
										name="conflict-{{row.dataIndex}}"
										[(ngModel)]="item.choice"
										[value]="-1"
										[disabled]="item.resolvedOnUpdate"
										(ngModelChange)="checkForResolutions(conflicts.items)"
										attr.data-qe-id="{{migrationSource.toLowerCase()}}-nucleus-migration-conflicts-conflict-new-record-select-button-{{row.dataIndex}}">
									<label for="existing-{{row.dataIndex}}">&nbsp;{{'onvio.setup.migrations.newRecord' | translate}}</label>
									<i class="bento-icon-info-filled grid-action-icon"
									ngbTooltip="{{'onvio.setup.migrations.createNewDescription' | translate}}"
									tooltipClass="bm-tooltip"
									container="body"
									triggers="click"
									attr.data-qe-id="{{migrationSource.toLowerCase()}}-nucleus-migration-conflicts-conflict-new-record-select-button-tooltip-{{row.dataIndex}}"></i>
								</span>
							</td>
							<td class="source-application-cell">
								<span class="font-weight-bold" attr.data-qe-id="{{migrationSource.toLowerCase()}}-nucleus-migration-conflicts-conflict-{{row.dataIndex}}-application-name">
									<span>{{productName}}</span>
									<span class="badge badge-info float-right">{{'onvio.setup.migrations.incoming' | translate}}</span>
								</span>
							</td>
							<td *ngFor="let prop of item.conflictEntityConfig.properties" class="conflict-data-table-cell">
								<div attr.data-qe-id="{{migrationSource.toLowerCase()}}-nucleus-migration-conflicts-conflict-{{row.dataIndex}}-new-record-{{prop.name}}">{{item.sourceEntityData[prop.name]}}</div>
							</td>
						</tr>
					</tbody>
					<!-- Existing/Similar Record body -->
					<tbody class="similar-records-row" data-qe-id="nucleus-migration-conflicts-conflict-{{row.dataIndex}}-similar-records"><tr><td>{{'onvio.setup.migrations.similarRecords' | translate}}</td></tr></tbody>
					<tbody>
						<ng-container *ngFor="let match of item.matches; let i = index;">
							<tr>
								<td class="match-input-cell">
									<span>
										<input
											type="radio"
											id="match-{{row.dataIndex}}-{{i}}"
											name="conflict-{{row.dataIndex}}"
											[(ngModel)]="item.choice"
											[value]="i"
											(ngModelChange)="checkForResolutions(conflicts.items)"
											attr.data-qe-id="{{migrationSource.toLowerCase()}}-nucleus-migration-conflicts-conflict-existing-record-{{row.dataIndex}}-select-button-{{i}}">
										<label for="match-{{row.dataIndex}}-{{i}}">&nbsp;{{'onvio.setup.migrations.useInsteadOfNew' | translate}}</label>
										<i class="bento-icon-info-filled grid-action-icon"
										ngbTooltip="{{'onvio.setup.migrations.matchDescription' | translate}}"
										tooltipClass="bm-tooltip"
										container="body"
										triggers="click"
										attr.data-qe-id="{{migrationSource.toLowerCase()}}-nucleus-migration-conflicts-conflict-existing-record-tooltip"></i>
									</span>
								</td>

								<td class="font-weight-bold" attr.data-qe-id="{{migrationSource.toLowerCase()}}-nucleus-migration-conflicts-conflict-{{row.dataIndex}}-existing-record-{{i}}-application-name">{{'onvio.setup.migrations.existingOnvioRecord' | translate:{'index': i + 1} }}</td>
								<!-- WIP FOR TOOLTIPS -->
								<!-- ngbTooltip="Matches source"
								container="body"
								#t="ngbTooltip"
								[disableTooltip]="match.data[prop.name] !== item.sourceEntityData[prop.name]"
								triggers="manual"
								(mouseenter)="openTooltip(t)"
								(mouseleave)="closeTooltip(t)" -->

								<!-- TODO: Add these back when we highlight cells -->
								<!-- class="conflict-data-table-cell"
								[style.background]="match.data[prop.name] === item.sourceEntityData[prop.name] ? '#d4ebf4' : 'unset'" -->
								<td *ngFor="let prop of item.conflictEntityConfig.properties">
									<div attr.data-qe-id="{{migrationSource.toLowerCase()}}-nucleus-migration-conflicts-conflict-{{row.dataIndex}}-existing-record-{{i}}-{{prop.name}}">{{match.data[prop.name]}}</div>
								</td>
							</tr>
						</ng-container>
					</tbody>
				</table>
				<div class="alert alert-info resolution-alert" [class.unresolved]="(item.isResolved$ | async) === false"><span>{{item.resolutionInfoTextKey$ | async | translate}}</span></div>
			</div>
		</ng-template>
		<!-- Grid Columns -->
		<wj-flex-grid-column [width]="40">
			<ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-row="row">
				<div attr.data-qe-id="{{migrationSource.toLowerCase()}}-nucleus-migration-conflicts-conflict-{{row.dataIndex}}-cell-id">{{row.dataIndex + 1}}</div>
			</ng-template>
		</wj-flex-grid-column>

		<wj-flex-grid-column [header]="'onvio.setup.migrations.conflictEntityType' | translate" [binding]="'conflictEntityType'" width="*">
			<ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item" let-row="row">
				<div attr.data-qe-id="{{migrationSource.toLowerCase()}}-nucleus-migration-conflicts-conflict-{{row.dataIndex}}-conflict-type">{{ item.conflictEntityConfig.translationKey | translate}}</div>
			</ng-template>
		</wj-flex-grid-column>

		<wj-flex-grid-column [header]="'onvio.setup.migrations.compareAndSelect' | translate" width="*">
			<ng-template wjFlexGridCellTemplate binding="matches.length" [cellType]="'Cell'" let-row="row" let-item="item">
				<span attr.data-qe-id="{{migrationSource.toLowerCase()}}-nucleus-migration-conflicts-conflict-expand-colapse-{{row.dataIndex}}">
					<i class="migration-conflict-expand-collapse-icon grid-action-icon" [class.bento-icon-expand]="!dp.isDetailVisible(row)" [class.bento-icon-collapse]="dp.isDetailVisible(row)" (click)="toggleDetail(row)"></i>
					<span [innerHTML]="'onvio.setup.migrations.similarRecordsNumber' | translate:{'records': item.matches.length}"></span>
				</span>
			</ng-template>
		</wj-flex-grid-column>

		<wj-flex-grid-column [header]="'onvio.setup.migrations.applicationEntityName' | translate: {'application': productName}" [binding]="'sourceEntityName'" width="*"></wj-flex-grid-column>

		<wj-flex-grid-column [header]="'onvio.setup.migrations.resolution' | translate" [binding]="'conflictResolution'" width="*">
			<ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item" let-row="row">
				<div attr.data-qe-id="{{migrationSource.toLowerCase()}}-nucleus-migration-conflicts-conflict-{{row.dataIndex}}-resolution">{{item.resolutionTextKey$ | async | translate:{'index':(item.choice$ | async) + 1} }}</div>
			</ng-template>
		</wj-flex-grid-column>

		<wj-flex-grid-column [header]="'onvio.setup.migrations.conflictStatus' | translate" [binding]="'conflictStatus'" width="*" >
			<ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item" let-row="row">
				<div class="status-indicator" [class.success]="item.isResolved$ | async" [class.warning]="(item.isResolved$ | async) === false">
					<div attr.data-qe-id="{{migrationSource.toLowerCase()}}-nucleus-migration-conflicts-conflict-{{row.dataIndex}}-status">{{ item.statusTextKey$ | async | translate}}</div>
				</div>
			</ng-template>
		</wj-flex-grid-column>
	</wj-flex-grid>
	<!-- Footer Toolbar -->
	<ng-container *ngIf="showFooterResolutionButton$ | async">
		<bento-toolbar class="bento-toolbar" data-qe-id="{{migrationSource.toLowerCase()}}-nucleus-migration-conflicts-footer-toolbar">
			<div class="navbar-right">
				<button
					class="btn btn-primary submit-button"
					(click)="submitResolved(conflicts.items)"
					[disabled]="resolutionButtonDisabled$ | async"
					attr.data-qe-id="{{migrationSource.toLowerCase()}}-nucleus-migration-conflicts-footer-submit-button">
					{{'onvio.setup.migrations.submitResolved' | translate}}
				</button>
			</div>
		</bento-toolbar>
	</ng-container>
</ng-container>
<ng-template #loading>
	<!-- TODO: Move to class -->
	<div [bentoBusyLoader]="true" [style.height]="'100px'"></div>
</ng-template>

